import { Injectable } from '@angular/core';
import { HttpWrapperService } from '@app/core/services/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import {
    IMigrateLotsWizardDocumentMigrateResponseDto,
    IMigrateLotsWizardDocumentAssignmentDto
} from '@classictechsolutions/hubapi-transpiled-enums';
import {
    IMigrateLotsWizardDocumentsLogicService
} from '@app/logic/migrate-lots-wizard-documents/interfaces/i.migrate-lots-wizard-documents.logic.service';

@Injectable()
export class MigrateLotsWizardDocumentsLogicService implements IMigrateLotsWizardDocumentsLogicService{
    public static readonly BASE_URI = 'migratelotswizarddocuments';

    constructor(protected readonly $http: HttpWrapperService) {}

    public migrateDocuments(
        assignments: IMigrateLotsWizardDocumentAssignmentDto[]
    ): Observable<IMigrateLotsWizardDocumentMigrateResponseDto> {
        return this.$http.post<IMigrateLotsWizardDocumentMigrateResponseDto>(
            `${MigrateLotsWizardDocumentsLogicService.BASE_URI}/migrate`,
            { assignments }
        );
    }
}
